import { betweenScreen } from '@doltech/core/lib/responsive/responsive.util';
import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import * as React from 'react';
import styled from 'styled-components';

import { useFromScreens } from '../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../colors-v2';

const Main = styled.div`
  background: ${colorsV2.blue10};
  border-radius: 62px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  grid-auto-columns: max-content;
  gap: 12px;
  padding: 8px 12px;
  height: 40px;
  max-height: 40px;
  .text {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${colorsV2.black100};
  }
  .close-icon {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-size: 16px;
    line-height: 0;
    color: ${colorsV2.white100};
    cursor: pointer;
    background-color: ${colorsV2.blue60};
    &:hover {
      transform: scale(1.05);
    }
    &:active {
      transform: scale(0.95);
    }
  }

  ${betweenScreen(0, 540)} {
    cursor: pointer;
    &:hover,
    &:active {
      background-color: ${colorsV2.blue20};
    }
  }
`;

interface FilterTagProps {
  text: string;
  onClose?: () => void;
}

export const FilterTag = ({ text, onClose }: FilterTagProps) => {
  const [, from540] = useFromScreens([0, 540]);
  return (
    <Main
      onClick={() => {
        if (from540) return;
        onClose();
      }}
      className="filter-tag"
    >
      <div className="text">{text}</div>
      <div
        onClick={() => {
          if (!from540) return;
          onClose();
        }}
        className="close-icon"
      >
        <IconOtherClose />
      </div>
    </Main>
  );
};
